import {isNil, mapObjIndexed} from 'ramda';

import type {PhotoCheckerPhotoEvaluationSaleVehiclePhoto} from '@dms/api/vehicle';

import type {PhotoCheckerPartVariants} from '../types/PhotoCheckerPartVariants';
import {getPhotoCheckerBadgeVariant} from './getPhotoCheckerBadgeVariant';
import {photoCheckerPhotoTypesByPart} from './photoCheckerPhotoTypesByPart';

const plainPartVariants = mapObjIndexed(
  () => 'plain',
  photoCheckerPhotoTypesByPart
) satisfies PhotoCheckerPartVariants;

export function getPhotoCheckerPartVariants(
  evals: PhotoCheckerPhotoEvaluationSaleVehiclePhoto[] | null | undefined
): PhotoCheckerPartVariants {
  if (isNil(evals)) {
    return plainPartVariants;
  }

  const partVariants = mapObjIndexed(
    (photoTypes) => getPhotoCheckerBadgeVariant(evals, photoTypes),
    photoCheckerPhotoTypesByPart
  ) satisfies PhotoCheckerPartVariants;

  return partVariants;
}
